// @core/api/endpoints/tenant/get_tenant_entitlements.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantEntitlementsResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant entitlements
 * Returns aggregated entitlements across all product subscriptions for the tenant. Includes features, seat limits, storage limits, and per-product breakdowns.
 */
export async function GetTenantEntitlements(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantEntitlementsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/entitlements`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantEntitlementsResponse>(requestPath, { ...requestOptions });
}
